/**
 * Calcula las casillas donde una unidad puede ser desplegada.
 * Lee el rango de despliegue directamente de las propiedades del jugador.
 *
 * @param {object} game   El estado completo del juego, que incluye al jugador actual.
 * @param {object} unit   La unidad seleccionada para desplegar.
 * @returns {Array<{x:number,y:number}>}
 */
export default function calculateDeployable(game, unit) {
  // 1. Validaciones iniciales
  if (!game || !unit || !game.players) {
    console.warn("[calculateDeployable] Missing essential data"); 
    return [];
  }

  // Get spawn beacons from the current snapshot
  
  if (!game) {
    console.warn("[calculateDeployable] No current game available");
    return [];
  }

  // Extract spawn beacons from structures
  const structures = game.dynamic_objects?.structures || [];
  const spawnBeacons = structures.filter(s => s.subtype === 'spawn_beacon');
  
  if (spawnBeacons.length === 0) {
    console.warn("[calculateDeployable] No spawn beacons found");
    return [];
  }

  // 2. Find current player and deployment range
  const currentPlayer = game.players.find(p => p.id === unit.player_id);
  const maxDist = currentPlayer?.pivot?.properties?.deployment_range;

  if (maxDist === undefined || maxDist === null) {
    console.warn(`[calculateDeployable] No deployment_range found for player ID: ${unit.player_id}`);
    return [];
  }
  
  // 3. Get team spawn beacons
  const currentTeam = currentPlayer?.pivot?.team;
  const teamBeacons = spawnBeacons.filter(b => {
    // Check teamClass or data.team for team affiliation
    if (b.teamClass === 'own' || b.teamClass === 'ally') return true;
    return b.data?.team === currentTeam;
  });
  
  if (!teamBeacons.length) {
    console.warn(`[calculateDeployable] No spawn beacons found for player's team`);
    return [];
  }

  // 4. Create set of occupied tiles
  const units = game.dynamic_objects?.units || [];
  const occupied = new Set(units.map((u) => `${u.x}-${u.y}`));
  structures.forEach(s => occupied.add(`${s.x}-${s.y}`));


  // 5. Calculamos las casillas válidas
  const tiles = [];
  for (let y = 0; y < game.map.height; y++) {
    for (let x = 0; x < game.map.width; x++) {
      if (occupied.has(`${x}-${y}`)) {
        continue;
      }

      const inRange = teamBeacons.some(
        (b) => Math.abs(b.x - x) + Math.abs(b.y - y) <= maxDist
      );
      
      if (inRange) {
        tiles.push({ x, y });
      }
    }
  }
  return tiles;
}